module.exports = __webpack_public_path__ + "static/img/tpMerchant.e7054cef.png";